import * as stylex from '@stylexjs/stylex';
import { colors } from '@/common/tokens.stylex';

const spin = stylex.keyframes({
  to: {
    transform: 'rotate(360deg)',
  },
});

export default function Spinner() {
  return <div {...stylex.props(styles.spinner)}></div>;
}

const styles = stylex.create({
  spinner: {
    width: 20,
    height: 20,
    borderWidth: 3,
    borderStyle: 'solid',
    borderLeftColor: colors.primaryColor,
    borderTopColor: colors.lighterGrey,
    borderRightColor: colors.lighterGrey,
    borderBottomColor: colors.lighterGrey,
    borderRadius: 9999,
    animationName: spin,
    animationDuration: '1s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
});
